import { useCallback, useState } from 'react';
import { Platform } from 'react-native';

import { useWindowMeasure } from '@/hooks/useWindowMeasure';

/**
 * Measures the KAV's vertical position on screen so `keyboardVerticalOffset`
 * can account for nested layouts (e.g. split-pane on tablets).
 *
 * Native-only; the measurement runs on the UI thread (see useWindowMeasure) to
 * avoid the JS-thread legacy measure path. `kavRef` attaches to the
 * KeyboardAvoidingView the consumer renders.
 * @param enabled Skip measurement when the KAV is full-screen (no offset needed).
 */
export function useKavVerticalOffset(enabled = true) {
  const { ref: kavRef, measureInWindow } = useWindowMeasure();
  const [kavVerticalOffset, setKavVerticalOffset] = useState(0);

  const handleKavLayout = useCallback(() => {
    if (Platform.OS === 'web' || !enabled) return;
    measureInWindow((_x, y) => {
      if (y > 0) {
        setKavVerticalOffset(y);
      }
    });
  }, [enabled, measureInWindow]);

  return { kavRef, kavVerticalOffset, handleKavLayout };
}
